import { useQuery } from "@tanstack/react-query";

import { ChartData } from "../../../../models/ChartCollectionData";
import DataSvc from "../../../../services/dataSvc";

/**
 * Takes in a chart collection ID,
 * fetches the charts in that collection,
 * and returns the one marked for individual facility use.
 */
export const useIndividualFacilityChart = (
  chartCollectionId: number | undefined
) => {
  const query = useQuery<ChartData | null>(
    ["chartData", chartCollectionId],
    async () => {
      const chartCollections = await DataSvc.getChartCollectionsByCollectionId(
        chartCollectionId?.toString()
      );

      return (
        chartCollections.find(
          ({ is_individual_use }: ChartData) => is_individual_use
        ) ?? null
      );
    },
    {
      enabled: !!chartCollectionId,
    }
  );

  return query;
};
